import type { LandingPageFeature } from '@/app/components/LandingPage/LandingPageFeatures/types';

const activityAndMovementFeaturesData: LandingPageFeature[] = [
  {
    id: 'score',
    title: 'activity_features_score_title',
    description: 'explore_activity_score_copy',
    image: {
      format: 'png',
      localizedAlt: 'activity_features_one_alt',
      localizedSrc: 'activity_features_one_img',
    },
  },
  {
    id: 'automatic',
    title: 'activity_automatic_title',
    description: 'explore_automatic_detection_copy',
    image: {
      format: 'png',
      localizedAlt: 'activity_features_two_alt',
      localizedSrc: 'activity_features_two_img',
    },
  },
  {
    id: 'personalized',
    title: 'activity_personalized_title',
    description: 'explore_personalized_goals_copy',
    image: {
      format: 'png',
      localizedAlt: 'activity_features_three_alt',
      localizedSrc: 'activity_features_three_img',
    },
  },
];

export default activityAndMovementFeaturesData;
